import React from 'react'
import Slider1 from '../assets/slider3.jpeg';
import Slider2 from '../assets/slider4.jpeg';
import Delhi from '../assets/destination/delhi.jpg';
import Mathura from '../assets/destination/mathura.jpg';
import Ayodhya from '../assets/destination/ayodhya.jpg';
import Manali from '../assets/destination/manali.jpg';
import Prayagraj from '../assets/destination/prayagraj.jpg'
import Haridwar from '../assets/destination/haridwar.jpg';
import Banaras from '../assets/destination/banaras.jpg';
import ChooseImg1 from '../assets/choose-img1.jpeg';
import ChooseImg2 from '../assets/choose-img2.jpeg';
import DefaultImg from '../assets/default-img.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import AboutMe from '../general/AboutMe';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* slider section */}
      <div id="carouselExampleControls" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="2000">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src={Slider1} class="d-block w-100" alt="Slider" />
            <div className='carousel-content'>
              <p className='fs-4 text-uppercase fw-bold my-0'>Tours & Travel</p>
              <p className='slider-heading mx-auto'>Discover Amazing places with us</p>
              <button className='slider-btn' onClick={() => navigate('/tour-booking')}>Book Now</button>
            </div>
          </div>

          <div class="carousel-item">
            <img src={Slider2} class="d-block w-100" alt="Slider" />
            <div className='carousel-content'>
              <p className='fs-4 text-uppercase fw-bold my-0'>Tours & Travel</p>
              <p className='slider-heading mx-auto'>Get Affordable Bookings with us</p>
              <button className='slider-btn' onClick={() => navigate('/contact')}>Enquire Now</button>
            </div>
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
          <i class="fa-solid fa-angle-left"></i>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
          <i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
      {/* slider section ends */}

      <AboutMe />

      {/* Destination section */}
      <section className='py-5 bg-light'>
        <div className='container px-lg-5 px-3 text-center'>

          <p className='sec-subheading'>Destination</p>
          <p className='sec-heading'>Explore Popular destinations</p>

          <div className='row mt-4'>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <div className='destination-area'>
                <img src={Delhi} className='img-fluid' alt='destination' />
                <div className='destination-content'>
                  <div className='destination-content-inner'><span className='fw-semibold fs-5'>Delhi</span></div>
                </div>
              </div>
              <div className="d-flex flex-wrap">
                <p className="my-0 pt-2 me-2"><Link to='tel:8858633908' className="slider-btn px-2 py-1 rounded-pill">Book on Call <i className="fa-solid fa-phone"></i></Link></p>
                <p className="my-0 pt-2"><Link to='https://wa.me/+919696359735' className="slider-btn px-2 py-1 rounded-pill">WhatsApp Chat <i className="fa-brands fa-whatsapp"></i></Link></p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <div className='destination-area'>
                <img src={Mathura} className='img-fluid' alt='destination' />
                <div className='destination-content'>
                  <div className='destination-content-inner'>Mathura</div>
                </div>
              </div>
              <div className="d-flex flex-wrap">
                <p className="my-0 pt-2 me-2"><Link to='tel:8858633908' className="slider-btn px-2 py-1 rounded-pill">Book on Call <i className="fa-solid fa-phone"></i></Link></p>
                <p className="my-0 pt-2"><Link to='https://wa.me/+919696359735' className="slider-btn px-2 py-1 rounded-pill">WhatsApp Chat <i className="fa-brands fa-whatsapp"></i></Link></p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <div className='destination-area'>
                <img src={Manali} className='img-fluid' alt='destination' />
                <div className='destination-content'>
                  <div className='destination-content-inner'>Manali</div>
                </div>
              </div>
              <div className="d-flex flex-wrap">
                <p className="my-0 pt-2 me-2"><Link to='tel:8858633908' className="slider-btn px-2 py-1 rounded-pill">Book on Call <i className="fa-solid fa-phone"></i></Link></p>
                <p className="my-0 pt-2"><Link to='https://wa.me/+919696359735' className="slider-btn px-2 py-1 rounded-pill">WhatsApp Chat <i className="fa-brands fa-whatsapp"></i></Link></p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <div className='destination-area'>
                <img src={Ayodhya} className='img-fluid' alt='destination' />
                <div className='destination-content'>
                  <div className='destination-content-inner'>Ayodhya</div>
                </div>
              </div>
              <div className="d-flex flex-wrap">
                <p className="my-0 pt-2 me-2"><Link to='tel:8858633908' className="slider-btn px-2 py-1 rounded-pill">Book on Call <i className="fa-solid fa-phone"></i></Link></p>
                <p className="my-0 pt-2"><Link to='https://wa.me/+919696359735' className="slider-btn px-2 py-1 rounded-pill">WhatsApp Chat <i className="fa-brands fa-whatsapp"></i></Link></p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <div className='destination-area'>
                <img src={Prayagraj} className='img-fluid' alt='destination' />
                <div className='destination-content'>
                  <div className='destination-content-inner'>Prayagraj</div>
                </div>
              </div>
              <div className="d-flex flex-wrap">
                <p className="my-0 pt-2 me-2"><Link to='tel:8858633908' className="slider-btn px-2 py-1 rounded-pill">Book on Call <i className="fa-solid fa-phone"></i></Link></p>
                <p className="my-0 pt-2"><Link to='https://wa.me/+919696359735' className="slider-btn px-2 py-1 rounded-pill">WhatsApp Chat <i className="fa-brands fa-whatsapp"></i></Link></p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <div className='destination-area'>
                <img src={Haridwar} className='img-fluid' alt='destination' />
                <div className='destination-content'>
                  <div className='destination-content-inner'>Haridwar</div>
                </div>
              </div>
              <div className="d-flex flex-wrap">
                <p className="my-0 pt-2 me-2"><Link to='tel:8858633908' className="slider-btn px-2 py-1 rounded-pill">Book on Call <i className="fa-solid fa-phone"></i></Link></p>
                <p className="my-0 pt-2"><Link to='https://wa.me/+919696359735' className="slider-btn px-2 py-1 rounded-pill">WhatsApp Chat <i className="fa-brands fa-whatsapp"></i></Link></p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <div className='destination-area'>
                <img src={Banaras} className='img-fluid' alt='destination' />
                <div className='destination-content'>
                  <div className='destination-content-inner'>Varanasi</div>
                </div>
              </div>
              <div className="d-flex flex-wrap">
                <p className="my-0 pt-2 me-2"><Link to='tel:8858633908' className="slider-btn px-2 py-1 rounded-pill">Book on Call <i className="fa-solid fa-phone"></i></Link></p>
                <p className="my-0 pt-2"><Link to='https://wa.me/+919696359735' className="slider-btn px-2 py-1 rounded-pill">WhatsApp Chat <i className="fa-brands fa-whatsapp"></i></Link></p>
              </div>
            </div>

          </div>
          {/* row ends */}

        </div>
      </section>
      {/* Destination section ends */}


      {/* Services section */}
      <section className='py-5 bg-light'>
        <div className='container px-lg-5 px-3 text-center'>

          <p className='sec-subheading'>Services</p>
          <p className='sec-heading'>Exclusive Tours & Travel Services</p>

          <div className='row mt-4'>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <div className='service-area px-3 py-4'>
                <i class="fa-solid fa-route service-icon"></i>
                <p className='fw-semibold mt-3 fs-5'>Travel Guide</p>
                <p className='text-muted'>Expert travel guides offering insightful tours, ensuring a memorable and informative travel experience.</p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <div className='service-area px-3 py-4'>
                <i class="fa-solid fa-car service-icon"></i>
                <p className='fw-semibold mt-3 fs-5'>Vehicle Booking</p>
                <p className='text-muted'>Convenient vehicle booking service for comfortable, reliable transportation tailored to your travel needs.</p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <div className='service-area px-3 py-4'>
                <i class="fa-solid fa-headset service-icon"></i>
                <p className='fw-semibold mt-3 fs-5'>Tour Assistance</p>
                <p className='text-muted'>Providing dedicated tour assistance to ensure smooth, hassle-free experiences throughout your journey.</p>
              </div>
            </div>


          </div>
          {/* row ends */}

        </div>
      </section>
      {/* Services section ends */}


      {/* why choose section */}
      <section className='choose-bg'>
        <div className='container px-lg-5 px-3'>

          <div className='row'>

            <div className='col-lg-7 col-12 my-4'>
              <p className='sec-subheading my-0'>Choose Omanshi Travels</p>
              <p className='sec-heading'>What makes us different?</p>

              <p><i class="fa-solid fa-check me-3 "></i>Unmatched Expertise: With years of experience, Omanshi Travels ensures seamless, well-planned travel experiences for all.<br /><br />
                <i class="fa-solid fa-check me-3"></i>Personalized Services: Offering customized travel solutions that cater to your unique preferences and needs.<br /><br />
                <i class="fa-solid fa-check me-3"></i>Reliable & Affordable: Providing high-quality services at competitive prices, ensuring great value for your travel experience.</p>
            </div>


            <div className='col-lg-5 col-12'>
              <div className='bg-white py-4 px-4'>
                <img src={ChooseImg1} className='img-fluid col-6' alt='choose' />
                <img src={ChooseImg2} className='img-fluid col-6' alt='choose' />
              </div>
            </div>

          </div>
          {/* row ends */}

        </div>
      </section>
      {/* why choose section ends */}


      {/* testimonials section */}
      <section className='py-5 bg-light'>
        <div className='container text-center'>

          <p className='sec-subheading'>Choose Omanshi Travels</p>
          <p className='sec-heading'>What makes us different?</p>

          <Swiper className='mt-4'
            spaceBetween={30}
            slidesPerView={3}
            modules={[Autoplay]}
            loop={true}
            autoplay={{
              delay: 2000
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                // width: 768,
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              }
            }}
          >

            <SwiperSlide>
              <div className='testimonial-area'>
                <img src={DefaultImg} className='img-fluid' alt='client' />
                <p className='text-muted mt-3'>"Omanshi Travels provided an unforgettable experience with exceptional service throughout our trip!"</p>
                <p className='fs-5 fw-semibold'>Miss Ruchi</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='testimonial-area'>
                <img src={DefaultImg} className='img-fluid' alt='client' />
                <p className='text-muted mt-3'>"The personalized service and attention to detail made our vacation stress-free and truly memorable. Low price at all."</p>
                <p className='fs-5 fw-semibold'>Mr Govind</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='testimonial-area'>
                <img src={DefaultImg} className='img-fluid' alt='client' />
                <p className='text-muted mt-3'>"Highly recommend Omanshi Travels for their professionalism, and affordable travel packages. Excellent service!"</p>
                <p className='fs-5 fw-semibold'>Mr Vikash</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='testimonial-area'>
                <img src={DefaultImg} className='img-fluid' alt='client' />
                <p className='text-muted mt-3'>"From booking to the trip, Omanshi Travels exceeded expectations with smooth arrangements and customer care."</p>
                <p className='fs-5 fw-semibold'>Mrs Riya</p>
              </div>
            </SwiperSlide>

          </Swiper>


        </div>
      </section>
      {/* testimonials section ends */}


    </>
  )
}

export default Home
